// https://github.com/vadimmarkov/webpack-es6-sass-boilerplate

import { qs, qsa } from './utils';

import axios from 'axios';
import { Dropbox } from 'dropbox';
import VanillaTilt from 'vanilla-tilt';

import WaveSurfer from 'wavesurfer.js';

const beatPanel = qs('.beat-panel');
const playerBtn = qs('.audio-player__button');
let panelItems;

import '../stylesheets/style.scss';

// Hide this at some stage
const accessToken = 'WkYV6vzbLcgAAAAAAAAAAeJgYvpayYP0k_uGNd0A-bwvQ_olUrKPpwhfrEAVj_yW';

const dbx = new Dropbox({
  accessToken,
  axios,
});

dbx
  .sharingListSharedLinks()
  .then((response) => {
    const beatsArray = response.result.links;
    return beatsArray;
  })
  .then((beatsArray) => {
    printToDom(beatsArray);
  })
  .then(() => {
    panelItems = qsa('.beat-panel__item');

    panelItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.getAttribute('data-url')) {
          loadBeat(e.target.getAttribute('data-url'));
        }
      });
    });
  });

const printToDom = (beatsArray) => {
  // clear placeholder panel
  beatPanel.innerHTML = '';
  for (let beat in beatsArray) {
    createBlockElem(beatsArray[beat].url, beatsArray[beat].name, beatsArray[beat].id, beat);
  }
};

const createBlockElem = (url, name, id, index) => {
  //modify url
  url = url.replace('www.', 'dl.');

  let displayName = '';
  for (let i = 1; i < 30; i++) {
    displayName += `<h3>${name}</h3>`;
  }

  const beatPanelItem = document.createElement('div');
  beatPanelItem.classList.add('beat-panel__item');
  beatPanelItem.innerHTML = `
  <div class="beat-panel__controls"></div>
  <div class="beat-panel__caption">${displayName}</div>

  `;
  beatPanelItem.setAttribute('data-url', url);
  VanillaTilt.init(beatPanelItem, {
    reverse: true,
    scale: 1.1,
  });
  beatPanel.appendChild(beatPanelItem);
};

var wavesurfer = WaveSurfer.create({
  container: '#waveform',
  waveColor: '#312102',
  progressColor: '#f7c25a',
});

// iOS fix for wavesurfer

var audioios = document.createElement('audio');
audioios.id = 'audio-player-iosfix';
audioios.src =
  'data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU2LjM2LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV6urq6urq6urq6urq6urq6urq6urq6urq6v////////////////////////////////8AAAAATGF2YzU2LjQxAAAAAAAAAAAAAAAAJAAAAAAAAAAAASDs90hvAAAAAAAAAAAAAAAAAAAA//MUZAAAAAGkAAAAAAAAA0gAAAAATEFN//MUZAMAAAGkAAAAAAAAA0gAAAAARTMu//MUZAYAAAGkAAAAAAAAA0gAAAAAOTku//MUZAkAAAGkAAAAAAAAA0gAAAAANVVV';
audioios.type = 'audio/mpeg';

// end iOS fix for waveSurfer

const loadBeat = (beatUrl) => {
  audioios.play();
  wavesurfer.setHeight(100);
  wavesurfer.load(beatUrl);
  wavesurfer.on('ready', function () {
    wavesurfer.play();
  });
};

// toggle play/pause btn

playerBtn.addEventListener('click', () => {
  wavesurfer.playPause();
  playerBtn.classList.toggle('active');
});

// repeat text bg

const bgFont = qs('.background-repeat');
let fontRepeated = `<h6 class="bg-font">beat a day</h6>`;
for (let i = 1; i < 100; i++) {
  fontRepeated += `<h6 class="bg-font">beat a day</h6>`;
}

bgFont.innerHTML = fontRepeated;
